import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Validator from 'vee-validate'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'supplier',
  components: {
    Paginate,
    VueElementLoading
  },
  props: ['value'],
  data() {
    return {
      modalShow: false,
      updatemerchantmodal: false,
      editmerchantmodal: false,
      addsuppliermodal: false,
      merchantaction: '',
      listClientData: [],
      listStateData: [],
      listCityData: [],
      listStateData1: [],
      listCityData1: [],
      listSupplierData: [],
      modalShow: false,
      modalMessageShow: false,
      displayMsg: false,
      successErrorMsg: "",
      supplyer: "",
      supplyerFlt: "",
      newActionMsg: "",
      modelMessage: "",
      pageCount: 0,
      pageNo: 0,
      activeClass: 'btn-success',
      warningClass: 'btn-warning',
      isLoading: false,
      resultCount: '',
      // initialize form field
      addsupplier: {
        supplierid: '',
        suppliercompanyname: '',
        supplieraddress: '',
        emailid: '',
        country: '',
        supplierstate: '',
        suppliercity: '',
        pincode: '',
        contactperson: '',
        phonenumber: '',
        suppliergstnno: '',
        druglicenseno: '',
        foodlicenseno: '',
        contactdetails: '',
        pannumber: '',
        supplieremailid: '',
        druglicensenodate: ''
      },
      status: '',
      changestatus: '',
      loginuserid: '',
      supplierid: '',
      showAddress: false,

    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    this.pageNo = 0
    this.getSupplyerList()
    this.getStateList();
    this.getStateList1();
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    //open new form(popup)
    addNewMerchant() {
      //to initialize all form field or used for clear the form
      this.addsupplier = [],
        this.merchantaction = 'add',
        this.addsuppliermodal = true;
      //to clear error messages(validation messages)
      this.$validator.reset();
      this.errors.clear();
    },
    addmodalShow() {
      this.Statusaction = 'add'
      this.addmodalShow = true
    },
    //to close active/inactive modal
    closeaddmodalShow() {
      this.addmodalShow = false
    },
    closeStatusMerchantModal() {
      this.modalShow = false
    },
    //to close new form
    closeAddMerchantModal() {
      this.addsuppliermodal = false
    },



    //to get state list
    getStateList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'stateList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listStateData = result.data
        }, error => {
          console.error(error)
        })
    },
    //depending on state ,get city list
    getCityList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        "statename": this.addsupplier.supplierstate
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cityList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listCityData = result.data
        }, error => {
          console.error(error)
        })
    },

    //to get state list
    getStateList1() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'stateList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listStateData1 = result.data
        }, error => {
          console.error(error)
        })
    },
    //depending on state ,get city list
    getCityList1() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        "statename": this.addsupplier.shiptostate
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cityList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listCityData1 = result.data
        }, error => {
          console.error(error)
        })
    },
    getSupplyerList(state = '') {

      if (this.supplyerFlt == '' && state != '') {
        this.displayMsg = "error";
        this.successErrorMsg = "Please supplier name.";
        return false;
      }

      this.input = ({
        offset: this.pageNo,
        limit: 10,
        supplyer: this.supplyerFlt.trim(),
      });
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'SupplierList',
          'data': this.input
        })
        .then(result => {
          this.listSupplierData = result.data.result;
          this.isLoading = false;
          let totalRows = result.data.result.length;
          this.resultCount = result.data.result.length
          if (totalRows < 10) {
            this.pageCount = 1
          } else {
            this.pageCount = Math.ceil(totalRows / 10)
          }
          if (this.listSupplierData.length == 0) {
            this.displayMsg = "error";
            this.successErrorMsg = this.$t('common.noRecordFound');
          } else {
            this.displayMsg = "";
          }
        }, error => {
          console.error(error)
        })
    },
    // save form fields in mysql database
    saveSupplier() {

      var userdetailEncrypt = window.localStorage.getItem('userdetail')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);


      if (this.addsupplier.suppliercompanyname == undefined || this.addsupplier.emailid == undefined || this.addsupplier.supplieraddress == undefined || this.addsupplier.country == undefined || this.addsupplier.supplierstate == undefined || this.addsupplier.suppliercity == undefined || this.addsupplier.phonenumber == undefined || this.addsupplier.pincode == undefined || this.addsupplier.suppliergstnno == undefined || this.addsupplier.druglicenseno == undefined || this.addsupplier.foodlicenseno == undefined || this.addsupplier.pannumber == undefined || this.addsupplier.contactperson == undefined || this.addsupplier.druglicensenodate == undefined) {
        return false
      } else {


        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = ({
          suppliercompanyname: this.addsupplier.suppliercompanyname,
          supplieraddress: this.addsupplier.supplieraddress,
          emailid: this.addsupplier.emailid,
          state: this.addsupplier.merchantstate,
          country: this.addsupplier.country,
          state: this.addsupplier.supplierstate,
          city: this.addsupplier.suppliercity,
          contactperson: this.addsupplier.contactperson,
          phonenumber: this.addsupplier.phonenumber,
          suppliergstnno: this.addsupplier.suppliergstnno,
          createdby: userdetail.email,
          modifiedby: userdetail.email,
          clientid: userdetail.clientid,
          supplierclientid: userdetail.clientid,
          pincode: this.addsupplier.pincode,
          druglicenseno: this.addsupplier.druglicenseno,
          foodlicenseno: this.addsupplier.foodlicenseno,
          contactdetails: this.addsupplier.contactdetails,
          pannumber: this.addsupplier.pannumber,
          supplieremailid: this.addsupplier.supplieremailid,
          druglicensenodate: this.addsupplier.druglicensenodate,


        })
        // console.log(this.input);
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'CreateSupplier',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then((response) => {
            if (response.data.msg == 1) {
              this.$alertify.success("Supplier Created Successfully")
              this.addsuppliermodal = false
              this.getSupplyerList();
            } else {
              (response.data.msg == 2)
              this.$alertify.error("Supplier already existed")
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    //to get target id in edit action
    getSupplierRowData(data) {
      console.log(data);
      this.$validator.reset();
      this.errors.clear();
      this.addsupplier.supplierstate = data.state;
      this.getCityList();
      this.merchantaction = 'edit'
      this.addsuppliermodal = true
      this.addsupplier = data
      this.addsupplier.supplierid = data.supplierid;
      this.addsupplier.suppliercity = data.city;
      this.addsupplier.supplierstate = data.state;

    },
    //update form fields
    editSupplier() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      var userdetailEncrypt = window.localStorage.getItem('userdetail')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);

      this.input = ({
        supplierid: this.addsupplier.supplierid,
        suppliercompanyname: this.addsupplier.suppliercompanyname,
        supplieraddress: this.addsupplier.supplieraddress,
        emailid: this.addsupplier.emailid,
        state: this.addsupplier.merchantstate,
        country: this.addsupplier.country,
        state: this.addsupplier.supplierstate,
        city: this.addsupplier.suppliercity,
        contactperson: this.addsupplier.contactperson,
        phonenumber: this.addsupplier.phonenumber,
        suppliergstnno: this.addsupplier.suppliergstnno,
        modifiedby: userdetail.email,
        supplierclientid: userdetail.clientid,
        pincode: this.addsupplier.pincode,
        druglicenseno: this.addsupplier.druglicenseno,
        foodlicenseno: this.addsupplier.foodlicenseno,
        pannumber: this.addsupplier.pannumber,
        druglicensenodate: this.addsupplier.druglicensenodate,


      });
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'updateSupplier',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.msg > 0) {
            this.$alertify.success("Supplier Record Updtaed Successfully");
            this.addsuppliermodal = false;
            this.getSupplyerList();
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //to get target id in active/inactive modal
    getStatusRowData(data) {
      this.Statusaction = 'add'
      this.modalShow = true
      this.supplierid = data.supplierid
      this.status = data.supplierstatus

      if (data.supplierstatus.trim() == 'Active') {
        this.changestatus = 'De-Activate'
      } else {
        this.changestatus = 'Activate'
      }

    },

    //for active/inactive modal
    changeSupplierStatus() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        supplierid: this.supplierid,
        status: this.status.trim(),
      });
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'updateSupplierStatus',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.msg > 0) {
            this.$alertify.success("Supplier Status update Successfully")
            this.addsuppliermodal = false
            this.getSupplyerList();
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1) * 10
      this.getSupplyerList()
    },

    resetForm() {
      this.supplyerFlt = '';
      this.getSupplyerList();
    },
    //validate all form fields on onsubmit()
    onSubmit: function(event) {
      this.$validator.validateAll().then(() => {
        event.target.reset();
        console.log('form is valid', this.model)
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }

  } // end methods

}


// WEBPACK FOOTER //
// ./src/views/components/supplierMaster/supplierMaster.component.js